export const projects = [
  {
    id: 19,
    title: "FinBoard - Finance Dashboard",
    description: "A real-time finance dashboard for tracking stock prices, market movers, and portfolio performance. Features live stock data with 30s refresh rates, candlestick charts, gainers/losers tracking, and a responsive design built with modern React patterns. Provides comprehensive market insights with open/high/low/close prices, volume data, and percentage changes.",
    techStack: ["React", "TypeScript", "Recharts", "Tailwind CSS", "Alpha Vantage API", "Vercel"],
    githubLink: "https://github.com/Meetjain1/FinBoard",
    deployedLink: "https://fin-board-khaki.vercel.app/",
  },
  {
    id: 3,
    title: "DocuAI: Local & Private Chat with Documents",
    description: "An AI-powered system for querying PDF documents locally, ensuring privacy with Ollama/WebLLM. Features real-time interaction, in-browser LLMs, RAG, and efficient local processing using Web Workers and IndexedDB.",
    techStack: ["Next.js", "Ollama", "WebLLM", "Web Workers", "IndexedDB", "Transformer.js", "LangChain", "WebGPU", "Clerk Auth"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://docu-ai-chi.vercel.app",
  },
  {
    id: 4,
    title: "Trackilo: Job Application Tracking System",
    description: "A MERN stack application designed to help users organize and monitor job applications. Features real-time updates via WebSockets, a modular Express.js backend (MVC), and efficient MongoDB schemas for fast queries.",
    techStack: ["MongoDB", "Express.js", "React", "Node.js", "WebSockets", "Redux", "Clerk Auth", "REST APIs", "JWT", "Tailwind CSS"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://trackilo.onrender.com",
  },
  {
    id: 1,
    title: "VoteOn: Decentralized Ethereum Voting System",
    description: "A fully tamper-proof and transparent e-voting platform leveraging Solidity smart contracts on Ethereum. Supports secure, real-time voting via MetaMask, with efficient backend voter management using FastAPI and MySQL.",
    techStack: ["Solidity", "Truffle", "Ganache", "Node.js", "MetaMask", "Python", "FastAPI", "MySQL", "Next.js", "Web3.js"],
    githubLink: "https://github.com/Meetjain1/VoteOn",
  },

  {
    id: 9,
    title: "Stoxify",
    description: "A React Native app for real-time stocks, charts, portfolio tracking, and market news that keeps you updated with live prices, lets you analyze trends through interactive charts, manage investments efficiently, create personalized watchlists, track gains and losses, and stay informed with the latest financial news all in one streamlined experience",
    techStack: ["React Native", "TypeScript", "Redux Toolkit", "Expo", "Alpha Vantage API", "React Navigation", "React Native Chart Kit", "AsyncStorage"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://drive.google.com/drive/folders/1yLEbj5_wUedeO4rft77c4ywRip3II_cN?usp=sharing",
  },
  {
    id: 10,
    title: "Data Alchemist",
    description: "A sophisticated web application designed to solve the common problem of messy spreadsheet management in resource allocation scenarios. Built with modern web technologies, this tool transforms chaotic CSV and Excel files into clean, validated, and intelligently processed data ready for downstream allocation systems.",
    techStack: ["Next.js", "React", "TypeScript", "Tailwind CSS", "Radix UI", "Shadcn/ui", "Lucide React", "React Hook Form", "PapaParse", "XLSX", "Framer Motion"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://data-alchemist-sigma-weld.vercel.app",
  },

  {
    id: 2,
    title: "Expenzo: Full-Stack Expense Tracker",
    description: "A MERN stack application for efficient personal finance management. Features robust APIs, dynamic data visualization with Chart.js, secure Google OAuth, and category-based tagging for insightful expense tracking.",
    techStack: ["MongoDB", "Express.js", "React", "Node.js", "Mongoose", "JWT", "Chart.js", "Ant Design", "Google OAuth"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://expenzo-fawn.vercel.app",
  },
  {
    id: 11,
    title: "TaskPilot AI: AI that pilots your computer tasks",
    description: "A scalable, production-ready AI-powered computer automation system featuring FastAPI backend, real-time WebSocket communication, persistent session management with SQLite, and VNC integration for visual desktop control. Enables Anthropic’s Claude to perform natural language-based computer operations with live feedback",
    techStack: [
  "Python",
  "FastAPI",
  "WebSockets",
  "SQLite",
  "SQLAlchemy",
  "Pydantic",
  "Uvicorn",
  "Docker",
  "Docker Compose",
  "Nginx",
  "HTML",
  "CSS",
  "JavaScript",
  "noVNC",
  "TigerVNC",
  "Anthropic Claude API"
],
    githubLink: "https://github.com/Meetjain1/TaskPilot-AI",
  },
  {
    id: 20,
    title: "Antrea Packet Capture Controller",
    description: "A minimal Kubernetes controller that enables on-demand packet capture for Pods using tcpdump. The controller runs as a DaemonSet and performs packet capture only for Pods scheduled on the same Node. Pods are selected using an annotation, and the controller manages capture lifecycle, including automatic cleanup when annotations are removed or Pods are deleted.",
    techStack: ["Go", "Kubernetes", "tcpdump", "Client-go", "DaemonSet", "Pod Events", "Kubernetes API"],
    githubLink: "https://github.com/Meetjain1/antrea-capture",
  },
  {
    id: 21,
    title: "DialGuard - Phone Directory and Spam Detection System",
    description: "A scalable phone directory and spam detection system built with Django REST Framework. Enables global contact management, spam detection, and user interaction tracking. Provides a RESTful API architecture suitable for integration with mobile or web clients and includes a responsive dashboard for analytics and monitoring. Features efficient database design, real-time spam flagging, secure authentication, and role-based access control.",
    techStack: ["Django", "Django REST Framework", "PostgreSQL", "Python", "REST API", "JWT Authentication"],
    githubLink: "https://github.com/Meetjain1/DialGuard",
  },
  {
    id: 12,
    title: "MarketPulse Monitor - E-commerce Price Monitoring Dashboard",
    description: "Streamlit-based dashboard that enables e-commerce businesses to track competitor pricing, compare with their own, and make smarter pricing decisions. With CSV data uploads, real-time analysis, and interactive visualizations, it helps identify opportunities, threats, and maintain a competitive edge.",
    techStack: [
  "Streamlit",
  "Pandas",
  "NumPy",
  "Plotly",
  "SQLite",
  "CSV"
],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://marketpulse-monitor.streamlit.app",
  },

  {
    id: 13,
    title: "Seller Performance Analytics Dashboard",
    description: "A modern, interactive dashboard that empowers e-commerce administrators to monitor seller performance in real time, track sales and revenue trends, analyze customer ratings and return patterns, and identify both top performers and underperformers. It provides actionable insights that drive business growth and enhance customer satisfaction.",
    techStack: [
  "Streamlit",
  "Plotly",
  "Python",
  "Pandas",
  "NumPy",
  "SQLAlchemy",
  "Scikit-learn",
  "NLTK",
  "PostgreSQL",
  "Faker",
  "Jupyter Notebook",
  "Git",
  "Streamlit Cloud"
],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://sellerscope-analytics.streamlit.app/",
  },

    {
    id: 14,
    title: "Customer Business Analysis Dashboard",
    description: "A powerful and easy-to-use dashboard that enables businesses to deeply understand customer behavior, identify key segments, predict churn, and receive actionable recommendations. It provides interactive visualizations, segmentation insights, and churn analysis in plain English, making it simple for teams to make data-driven decisions without advanced analytics expertise.",
    techStack: ["Python", "Streamlit", "SQLite", "Pandas", "Plotly"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://insightstream.streamlit.app/",
  },

  {
    id: 7,
    title: "Brake-by-Wire System Failure Prediction ML Model",
    description: "A machine learning project simulating sensor data from a Brake-by-Wire system to predict FMEA failure indicators (Severity, Occurrence, Detection) using various regression models.",
    techStack: ["Python", "Pandas", "Scikit-learn", "XGBoost", "Matplotlib", "Seaborn"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://colab.research.google.com/drive/1lxe7pV7Kq9zdPoZyASP_RLl7q-hEM4G7?usp=sharing",
  },
  {
    id: 5,
    title: "AI-Powered Ship Management System",
    description: "An intelligent system optimizing ship routes and fuel consumption with 95% accuracy using TensorFlow.js. Includes predictive maintenance and scalable microservices deployed with Docker.",
    techStack: ["Node.js", "MongoDB", "TensorFlow.js", "Docker", "Swagger", "Jest"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://ai-powered-ship-management-system.onrender.com/api-docs",
  },
  {
    id: 6,
    title: "Event Management System",
    description: "A RESTful API built with FastAPI for managing events, featuring collaborative editing, version control, role-based access, and real-time updates. Provides comprehensive Swagger documentation.",
    techStack: ["FastAPI", "PostgreSQL", "SQLAlchemy", "Alembic", "Redis", "Pydantic", "JWT"],
    githubLink: "YOUR_GITHUB_LINK_HERE", 
    deployedLink: "https://event-management-system-7j6g.onrender.com/docs", 
  },
  {
    id: 8,
    title: "Chapter Performance Dashboard API",
    description: "A RESTful API for managing chapter performance data with advanced features like Redis caching (1-hour TTL), rate limiting (30 req/min), admin authentication, and comprehensive filtering. Includes Swagger documentation and Postman collection.",
    techStack: ["TypeScript", "Node.js", "MongoDB", "Redis", "JWT", "Swagger", "Mongoose", "Express.js"],
    githubLink: "YOUR_GITHUB_LINK_HERE",
    deployedLink: "https://chapter-performance-dashboard-api.onrender.com/docs/",
  },
  {
    id: 15,
    title: "Evently - Enterprise Event Management Platform",
    description: "Evently is a production-ready, enterprise-grade backend platform for large-scale event management and ticketing. It provides a modular, TypeScript-based API (Express + TypeORM) with features like multi-role JWT auth, seat-level booking, intelligent waitlists, advanced booking engine, revenue & occupancy analytics, and automatic Swagger/OpenAPI docs. Designed for scalability and security with PostgreSQL, Redis caching, migration-driven schema updates, and CI-friendly conventions. The deployed API docs are available for interactive exploration.",
    techStack: ["TypeScript", "Node.js", "Express.js", "TypeORM", "PostgreSQL", "Redis", "Swagger", "Jest", "Docker", "Render"],
    githubLink: "https://github.com/Meetjain1/Evently",
    deployedLink: "https://evently-om2i.onrender.com/api-docs/",
    // deployedLinkType: "docs",
  },

  {
    id: 16,
    title: "RefNet-Engine - Referral Network System",
    description: "RefNet-Engine is a compact, well-tested TypeScript library and demo app that implements referral-network graph management, cycle-safe referral addition, BFS-based reach calculations, influence & centrality metrics, and a growth simulation engine with binary-search bonus optimization. It includes a comprehensive Jest test-suite and focuses on correctness and algorithmic clarity for business analytics and simulation use-cases.",
    techStack: ["TypeScript", "Node.js", "Jest", "Algorithms", "Graph Theory"],
    githubLink: "https://github.com/Meetjain1/RefNet-Engine",
  },

  {
    id: 17,
    title: "MGNREGA Dashboard - Our Voice, Our Rights",
    description: "A production-ready web application providing MGNREGA (Mahatma Gandhi National Rural Employment Guarantee Act) data to rural Indian citizens through an accessible, low-literacy friendly interface. Covers 115 districts across 5 states (Bihar, Maharashtra, Rajasthan, Uttar Pradesh, West Bengal) with bilingual support (Hindi/English), automatic GPS location detection, real-time search, and responsive design optimized for mobile and desktop.",
    techStack: ["Next.js", "React", "TypeScript", "TailwindCSS", "Prisma ORM", "PostgreSQL", "SWR", "Jest", "React Testing Library"],
    githubLink: "https://github.com/Meetjain1/MGNREGA-Performance-Tracker",
    deployedLink: "https://mgnrega-performance-tracker.vercel.app/",
  },

  {
    id: 18,
    title: "Branch CS Messaging Web Application",
    description: "A real-time messaging web application for Branch customer service agents to handle customer inquiries efficiently. Features multi-agent system support, Socket.io WebSocket for instant message delivery, automatic urgency detection for high-priority messages, customer context with enriched profiles, canned message templates, and CSV import for customer data management.",
    techStack: ["React", "Node.js", "Express", "MongoDB", "Socket.io", "Vite", "Docker", "Postman"],
    githubLink: "https://github.com/Meetjain1/BranchMessageHub",
  },
];
